import { HeaderOnlyLayout } from '@layouts/header-only-layout/HeaderOnlyLayout';
import { AppLoader } from '@shared/components/app-loader/AppLoader';
import { ErrorPage } from '@shared/components/error-pages/ErrorPage';
import { InlineFeedback } from '@shared/components/inline-feedback/InlineFeedback';
import * as React from 'react';

import type { OrganizationRouteGuardProps } from './OrganizationRouteGuard.types';

import { useOrganizationGuard } from './hooks/use-organization-guard/useOrganizationGuard';

/**
 * OrganizationRouteGuard - Guards Manage module routes (/manage/:customerId).
 * Delegates all state logic to useOrganizationGuard and renders based on status.
 */
const OrganizationRouteGuard = React.memo(
  ({ children }: Readonly<OrganizationRouteGuardProps>): React.ReactElement => {
    const state = useOrganizationGuard();

    switch (state.status) {
      case 'loading':
        return <AppLoader />;
      case 'error':
        return <ErrorPage type="internal-server-error" />;
      case 'not-found':
        return (
          <HeaderOnlyLayout>
            <InlineFeedback type="not-found" />
          </HeaderOnlyLayout>
        );
      case 'ready':
        return <>{children}</>;
    }
  }
);

OrganizationRouteGuard.displayName = 'OrganizationRouteGuard';

export { OrganizationRouteGuard };
